<template>
  <div ref="Memoram" class="text-justify transparent">
    <h1 class="text-center">Memoram</h1>
    <hr class="primary" />
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Memoram"
};
</script>
